<template>
	<v-btn @click="setEdit" class="btn-widget-form-done">{{ value }}</v-btn>
</template>

<script>
import WidgetService from '@/utils/WidgetService';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'SubmitButtonSettings',
	props: {
		disabled: { type: Boolean },
	},
	computed: {
		...mapGetters('widgetEditor', ['widgetMetadata', 'widgetFields']),
		value: {
			get() {
				return this.widgetMetadata?.options
					? WidgetService.getDoneBtnLabel({ widgetFields: this.widgetFields, submitText: this.widgetMetadata.options.submit_text })
					: null;
			},
			set(value) {
				this.setWidgetOption({ key: 'submit_text', value: { value } });
			},
		},
	},
	methods: {
		...mapActions('widgetEditor', ['setWidgetOption']),
		setEdit() {
			if (!this.disabled) {
				this.isEdit = true;
				this.$nextTick(() => this.$refs.btnInput.focus());
			}
		},
	},
	data() {
		return { isEdit: false };
	},
};
</script>

<style scoped lang="scss"></style>
